const NAMESPACE = "automationActionName";

const KEYS = {
    AddAccessGroup: "AddAccessGroup",
    CallWebAdapter: "CallWebAdapter",
    ChangeStatus: "ChangeStatus",
    ClearAssignee: "ClearAssignee",
    GenerateAttachment: "GenerateAttachment",
    PauseDeadline: "PauseDeadline",
    RemoveAccessGroup: "RemoveAccessGroup",
    ResumeDeadline: "ResumeDeadline",
    RunReport: "RunReport",
    SatisfyDeadline: "SatisfyDeadline",
    SendCommunication: "SendCommunication",
    SetDataField: "SetDataField",
    SetDeadline: "SetDeadline",
    SignalToChannel: "SignalToChannel",
    RequestESignature: "RequestESignature",
    ClearDataField: "ClearDataField"
};
const MESSAGES = {
    [KEYS.AddAccessGroup]: {
        value: "Add Access Group",
        comment: "Name for Add Access Group automation action. Shown in a dropdown"
    },
    [KEYS.CallWebAdapter]: {
        value: "Call Connection",
        comment: "Name for Call Connection automation action. Shown in a dropdown"
    },
    [KEYS.ChangeStatus]: {
        value: "Change Project Status",
        comment: "Name for Change Project Status automation action. Shown in a dropdown"
    },
    [KEYS.ClearAssignee]: {
        value: "Clear Assignee",
        comment: "Name for Clear Assignee automation action. Shown in a dropdown"
    },
    [KEYS.GenerateAttachment]: {
        value: "Generate Attachment",
        comment: "Name for Generate Attachment automation action. Shown in a dropdown"
    },
    [KEYS.PauseDeadline]: {
        value: "Pause Deadline",
        comment: "Name for Pause Deadline automation action. Shown in a dropdown"
    },
    [KEYS.RemoveAccessGroup]: {
        value: "Remove Access Group",
        comment: "Name for Remove Access Group automation action. Shown in a dropdown"
    },
    [KEYS.ResumeDeadline]: {
        value: "Resume Deadline",
        comment: "Name for Resume Deadline automation action. Shown in a dropdown"
    },
    [KEYS.RunReport]: {
        value: "Run Report",
        comment: "Name for Run Report automation action. Shown in a dropdown"
    },
    [KEYS.SatisfyDeadline]: {
        value: "Satisfy Deadline",
        comment: "Name for Satisfy Deadline automation action. Shown in a dropdown"
    },
    [KEYS.SendCommunication]: {
        value: "Send Communication",
        comment: "Name for Send Communication automation action. Shown in a dropdown"
    },
    [KEYS.SetDataField]: {
        value: "Set Data Field",
        comment: "Name for Set Data Field automation action. Shown in a dropdown"
    },
    [KEYS.SetDeadline]: {
        value: "Set Deadline",
        comment: "Name for Set Deadline automation action. Shown in a dropdown"
    },
    [KEYS.SignalToChannel]: {
        value: "Send Signal to Channel",
        comment: "Name for Send Signal to Channel automation action. Shown in a dropdown"
    },
    [KEYS.RequestESignature]: {
        value: "Request eSignature",
        comment: "Name for Request eSignature automation action. Shown in a dropdown"
    },
    [KEYS.ClearDataField]: {
        value: "Clear Data Field",
        comment: "Name for Clear Data Field automation action. Shown in a dropdown"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
